import React, { useEffect, useState } from 'react';
import twinseyeLogo from '../images/TwinSeye-Logo-Text.png';
import backgroundImage from "../images/BackgroundForIntroPage.png";
import styles from './IntroPages.module.css';
import { getText } from '../languageutil/translations';
import { getLanguageBasedImage } from '../languageutil/ImageUtil';

function IntroInfoPage({ navigate }) {
  const [startButtonImage, setStartButtonImage] = useState(null);

  useEffect(() => {
    setStartButtonImage(getLanguageBasedImage('BaslaButton.png'));
  }, []);

  return (
    <div className={styles.intropage} style={{ backgroundImage: `url(${backgroundImage})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}>
      <div className={styles.content}>
      <div style={{ position: "absolute", top: "0vh", left: "0vw", height: "20vh", width: "100vw", backgroundColor: "white" }} />
      <img src={twinseyeLogo} alt="CoreXFuture" style={{ position: "absolute", top: "3vh", left: "4vw", height: "14vh", alignSelf: "center" }} />
        <div style={{ width: "70%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh", margin: 0, paddingTop: "10vh" }}>
          <h2 className={styles.subtitle}>{getText('welcomeTechTitle')}</h2>
          <p className={styles.description}>{getText('welcomeTechDescription')}</p>
        </div>
        <div className={styles.rightside}>
          <div className={styles.buttoncontainer}>
            <img 
              src={startButtonImage} 
              alt={getText('startButton')} 
              className={styles.startbutton} 
              onClick={() => { navigate('/quiz/technology/OperasyonAnaBoyut.json/OPERASYON') }} 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntroInfoPage;
